import { useState, useEffect } from "react";
import { addFavorite, createArticle, getOriginArticleFromLink, uploadFeaturedImage } from "../../HTTP/articles";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { countries, languages } from "../../global/countriesAndSources";
import { getAllLanguagesFromCountry } from "../../HTTP/translation";
import DeleteIcon from '@mui/icons-material/Delete';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import constants from "../../HTTP/constants";
import { VISIBILITY_OPTIONS } from "../../Helper/visibilityOptions";

export default function MyArticlesCreate() {
    if (localStorage.getItem("subscriptions") === null) {
        window.location.href = '/'
    } else {
      if (JSON.parse(localStorage.getItem("subscriptions")).data === null) {
        window.location.href = '/'
      }
    }
    const user = JSON.parse(localStorage.getItem("user"))
    const [languagesOfUser, setLanguagesOfUser] = useState([])
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        language: '',
        image: null,
        imagePreview: '',
        visible: 0,
        copyright: false,
        rotation_featured_image: 0 // Ajout d'un état pour suivre la rotation_featured_image
    });
    const [favorites, setFavorites] = useState(JSON.parse(localStorage.getItem('favorites') || []));
    
    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        
        if (type === 'file') {
            const file = files[0];
            if (file) {
                if (!file.type.startsWith('image/')) {
                    alert('Veuillez sélectionner une image valide');
                    return;
                }
                
                if (file.size > 5 * 1024 * 1024) {
                    alert('L\'image ne doit pas dépasser 5MB');
                    return;
                }
                
                const previewUrl = URL.createObjectURL(file);
                
                setFormData(prevData => ({
                    ...prevData,
                    image: file,
                    imagePreview: previewUrl,
                    copyright: false, // Réinitialise le copyright quand une nouvelle image est chargée
                    rotation_featured_image: 0 // Réinitialise la rotation_featured_image
                }));
            }
        } else {
            setFormData(prevData => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const handleRemoveImage = () => {
        if (formData.imagePreview) {
            URL.revokeObjectURL(formData.imagePreview);
        }
        
        setFormData(prevData => ({
            ...prevData,
            image: null,
            imagePreview: '',
            copyright: false, // Réinitialise le copyright quand l'image est supprimée
            rotation_featured_image: 0 // Réinitialise la rotation_featured_image
        }));
        
        const fileInput = document.getElementById('image');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    useEffect(() => {
        return () => {
            if (formData.imagePreview) {
                URL.revokeObjectURL(formData.imagePreview);
            }
        };
    }, [formData.imagePreview]);
    
    const handleSubimeChange = (content) => {
        setFormData(prevData => ({
            ...prevData,
            description: content
        }));
    }
    
    useEffect(() => {
        const funGetLanguages = async () => {
            const langFromUser = await getAllLanguagesFromCountry(user.country)
            setLanguagesOfUser(langFromUser)
        }
        funGetLanguages()
    }, [user.country])
    
    useEffect(() => {
        setFormData(prevData => ({
            ...prevData,
            language: languagesOfUser[0]
        }))
    }, [languagesOfUser])

    // Vérifie si le formulaire peut être soumis
    const isSubmitDisabled = formData.image && !formData.copyright;

    const handleArticleToFavorite = async (title, link, image, country, date, description) => {
        const favorite = {
          title: title,
          link: link,
          image: image || "",
          country: country,
          publication_date: date,
          description: description
        };
    
        try {
          const res = await addFavorite(favorite);
          if (res.ok === true) {
            favorite.id = res.id;
            const updatedFavorites = [favorite, ...favorites];
            setFavorites(updatedFavorites);
            localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
            alert('Article added to favorites !');
          }
        } catch (error) {
          console.error('An error has occured when adding the favorite', error);
          alert('An error has occured when adding the favorite');
        }
      };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const visibleArticle = Number(formData.visible)
            const res = await createArticle(user.id, formData.title, formData.description, formData.language === '' ? languagesOfUser[0] : formData.language, visibleArticle, formData.rotation_featured_image)
            console.log(res)
            if (res.articleId && visibleArticle === 1) {
                await handleArticleToFavorite(formData.title, `https://static.zemus.info/article/?id=${res.articleId}`, constants.API_URL + `/article/${res.articleId}/featured_image`, countries.find((country) => country.code === user.country).name, new Date().toISOString().replace("T", " ").slice(0, 19), formData.description.replace(/<[^>]+>/g, '').slice(0, 200) + '...')
            }
            if (formData.image) {
                const res2 = await uploadFeaturedImage(res.articleId, formData.image)
                console.log(res2)
                alert('Article added successfully with image')
            } else {
                alert('Article added successfully without image')
            }
            window.location.href = '/myarticles'
        } catch (err) {
            alert("An error occured while saving the article");
        }
    };

    const handleRotateImage = () => {
        if (formData.imagePreview) {
            // Mettre à jour la rotation_featured_image dans l'état au lieu de manipuler directement le DOM
            setFormData(prevData => ({
                ...prevData,
                rotation_featured_image: (prevData.rotation_featured_image + 90) % 360
            }));
        }
    }

    return (
        <div className="mt-8 max-w-md mx-auto p-6 bg-white rounded-lg shadow-md md:overflow-y-auto" style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 100px)' : undefined }}>
            <h2 className="text-2xl font-bold mb-6 text-center">Formulaire Article</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="title" className="block text-gray-700 text-sm font-bold mb-2">
                        Titre
                    </label>
                    <input
                        type="text"
                        id="title"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="language" className="block text-gray-700 text-sm font-bold mb-2">
                        Langue de l'article
                    </label>
                    <select 
                        value={formData.language} 
                        onChange={handleChange} 
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                        name="language"
                    >
                        {
                            languages.map((l, i) => <option value={l.language_code} key={i}>{l.language_name}</option>)
                        }
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="image" className="block text-gray-700 text-sm font-bold mb-2">
                        Afficher une image
                    </label>
                    <div className="flex gap-2">
                        <input
                            type="file"
                            id="image"
                            name="image"
                            accept="image/*"
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        {formData.image && (
                            <>
                            <button
                                type="button"
                                onClick={handleRotateImage}
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold px-3 rounded focus:outline-none focus:shadow-outline"
                                >
                                <RotateRightIcon />
                            </button>
                            <button
                                type="button"
                                onClick={handleRemoveImage}
                                className="bg-red-500 hover:bg-red-700 text-white font-bold px-3 rounded focus:outline-none focus:shadow-outline"
                            >
                                <DeleteIcon />
                            </button>
                            </>
                        )}
                    </div>
                    {formData.imagePreview && (
                        <div className="mt-2 relative overflow-hidden w-full h-56 flex items-center justify-center">
                            {/* Conteneur avec une hauteur fixe et overflow hidden */}
                            <div className="w-4/5 h-4/5 flex items-center justify-center">
                                <img
                                    src={formData.imagePreview}
                                    alt="Preview"
                                    className="image-preview max-w-full max-h-full object-contain"
                                    style={{ 
                                        transform: `rotate(${formData.rotation_featured_image}deg)`,
                                        transformOrigin: 'center center',
                                        transition: 'transform 0.3s ease'
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {formData.image && (
                        <div className="mb-6">
                            <label className="flex items-center">
                                <input
                                    type="checkbox"
                                    name="copyright"
                                    checked={formData.copyright}
                                    onChange={handleChange}
                                    className="form-checkbox h-5 w-5 text-blue-600"
                                />
                                <span className="ml-2 text-gray-700">Je suis l'auteur de l'image à la une ou j'ai les droits d'utilisation</span>
                            </label>
                        </div>
                    )}
                </div>
                <div className="mb-4">
                    <label htmlFor="description" className="block text-gray-700 text-sm font-bold mb-2">
                        Description
                    </label>
                    <span className="text-gray-500 text-xs">Conseil : copiez et collez des images libres de droits depuis Internet.</span>
                    <ReactQuill
                        theme="snow"
                        value={formData.description}
                        onChange={handleSubimeChange}
                        className="notranslate mt-1"
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="visible" className="block text-gray-700 text-sm font-bold mb-2">
                        Visibilite
                    </label>
                    <select
                        id="visible"
                        name="visible"
                        value={formData.visible}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        {VISIBILITY_OPTIONS.map((option) => (
                            <option value={option.value} key={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        disabled={isSubmitDisabled}
                        className={`${
                            isSubmitDisabled 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-blue-500 hover:bg-blue-700'
                        } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );
}
